import {EventEmitter, LenisScroll} from "./utils.js";

const eventEmitter = new EventEmitter();
const lenisScrollInstance = new LenisScroll(eventEmitter);
lenisScrollInstance.initialize();
const commonFnc = (()=>{

  const isMobile = () => {

    const method = {
      mobileCheck : ()=> /Mobi|Android/i.test(navigator.userAgent),
      sizeCheck: () => innerWidth,
      onResize : () => {
        method.mobileCheck()
        method.sizeCheck()
      }
    }

    window.addEventListener('resize',method.onResize)

    return{
      mobileCheck : method.mobileCheck(),
      sizeCheck : method.sizeCheck()
    }
  }

  const setVHVariable = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', setVHVariable);
  }
  setVHVariable();

  const headerHandler = () => {
    const objs ={
      el:{
        main:document.querySelector('main'),
        header:document.querySelector('header'),
        visual:document.querySelector('.main__visual'),
      },
      data:{
        headerHeight:0,
        visualHeight:0,
        state: {
          onTop:false,
          onPosition:false,
          onScroll:false,
          onVisual:false,
          onHeaderMotion:false,
        },
      }
    }

    const method = {
      isScroll : (e)=>{
        if(objs.data.state.onHeaderMotion) return;

        if(objs.el.main.scrollTop > objs.data.headerHeight && !objs.data.state.onTop){
          objs.data.state.onTop = true;
          objs.el.header.classList.add('onTop');
        }

        if(objs.el.main.scrollTop <= objs.data.headerHeight && objs.data.state.onTop){
          objs.data.state.onTop = false;
          objs.el.header.classList.remove('onTop');
        }

        if(objs.el.main.scrollTop > objs.data.visualHeight/2 && !objs.data.state.onPosition){
          objs.data.state.onPosition = true;
          objs.el.header.classList.add('onPosition');
        }

        if(objs.el.main.scrollTop <= objs.data.visualHeight/2 && objs.data.state.onPosition){
          objs.data.state.onPosition = false;
          objs.el.header.classList.remove('onPosition');
        }

        if(objs.el.main.scrollTop > objs.data.visualHeight && !objs.data.state.onScroll){
          objs.data.state.onScroll = true;
          objs.el.header.classList.add('onScroll');
        }

        if(objs.el.main.scrollTop <= objs.data.visualHeight && objs.data.state.onScroll){
          objs.data.state.onScroll = false;
            objs.el.header.classList.remove('onScroll');
          objs.el.header.classList.remove('show');
        }

        if(objs.el.header.classList.contains('onScroll')){
          if(e.direction > 0 && !objs.data.state.onVisual){
            objs.data.state.onVisual = true;
            objs.el.header.classList.remove('show');
          }
          if(e.direction < 0 && objs.data.state.onVisual){
            objs.data.state.onVisual = false;
            objs.el.header.classList.add('show');
          }
        }

      },
      setData : ()=>{
        objs.data.headerHeight = objs.el.header.offsetHeight;
        objs.data.visualHeight = window.innerHeight;
      },
      onResize : ()=>{
        method.setData()
      },
    }

    const bindEvent = () => {
      eventEmitter.on('scroll',method.isScroll);
    };

    const init = () => {
      method.setData();
      method.onResize();
      bindEvent();
    };

    init();
  };
  headerHandler();

  const navigationHandler = ()=>{
    const header = document.querySelector('header');
    const gnbWrap = document.querySelector('.header__gnb-wrap');
    const siteMap = document.querySelector('.c__sitemap');
    const siteMapMobItem = siteMap.querySelectorAll('.sitemap-nav');
    const siteMapMobLink = siteMap.querySelectorAll('h2');
    const button = document.querySelector('.header__all-btn');
    const logo = document.querySelector('.header__logo');

    let state = false;

    button.addEventListener('click',()=>{
      state = !state;
      if(state){
        if(header.classList.contains('show') || header.classList.contains('theme-white')){
          logo.classList.add('onScroll');
          button.classList.add('onScroll');
        }

        button.classList.add('open');
        gnbWrap.style.display = "none";
        siteMap.style.display = "flex";
        lenisScrollInstance.destroy();
      }else{
        logo.classList.remove('onScroll');
        button.classList.remove('onScroll');
        button.classList.remove('open');
        gnbWrap.style.display = "flex";
        siteMap.style.display = "none";
        lenisScrollInstance.initialize();
      }
    })

    const handleResize =()=> {
      const isMobile = window.matchMedia('(max-width: 650px)').matches;

      if (!isMobile) {
        siteMapMobItem.forEach(gnbItems => {
          gnbItems.classList.remove('active');
        })
      }
    }

    const handleClick =()=> {
      siteMapMobLink.forEach(linkLists => {
        linkLists.addEventListener('click', (list)=> {
          if (window.matchMedia('(max-width: 650px)').matches) {
            siteMapMobItem.forEach(gnbItems => {
              gnbItems.classList.remove('active');
            })
            list.currentTarget.parentNode.classList.add('active');
          }
        })
      });
    }

    const resize =()=> {
      handleResize();
      handleClick();
    }

    const init =()=> {
      handleResize();
      handleClick();
      window.addEventListener('resize', resize);
    }
    
    init();
  }
  navigationHandler();

  const lnbHandler = () =>{
    const objs = {
      el: {
        main: document.querySelector('main'),
        header:document.querySelector('header'),
        visual: document.querySelector('.sub__visual-video'),
        navWrap: document.querySelector('nav.lnb__wrap'),
        navOpenBtns: document.querySelectorAll('nav.lnb__wrap .open-btn'),
        lnbBtn: document.querySelector('nav.lnb__wrap .breadCrumb .open-btn'),
        lnbPath: document.querySelector('[data-path]'),
        lnbList: document.querySelectorAll('nav.lnb__wrap .breadCrumb li'),
        scrollBtn: document.querySelector('nav.lnb__wrap .c__container .open-btn'),
        scrollList: document.querySelectorAll('nav.lnb__wrap .page__list a'),
      },
      state:{
        distance : 0,
        isAccordionActive: false,
      }
    }

    const method = {
      setTheHeight : ()=>{
        const {offsetHeight : visualHeight} = objs.el.visual;
        const {offsetHeight : navHeight} = objs.el.navWrap;
        objs.state.distance = visualHeight - navHeight;
      },
      checkDistance: (_distance)=>{
        if(objs.el.main.scrollTop >= _distance){
          objs.el.navWrap.classList.add('active');
        }else{
          objs.el.navWrap.classList.remove('active');
        }
      },
      checkCurrentLink: ()=> {
        const currentLink = objs.el.lnbPath.getAttribute('data-path');
        
        objs.el.lnbList.forEach(list => {
          if (list.getAttribute('data-link') === currentLink) {
            list.classList.add('active');
            objs.el.lnbBtn.innerText = list.innerText;
          }
        })
      },
      toggleAccordionListeners: (add)=> {
        objs.el.navOpenBtns.forEach(btn => {
          if (add) {
            btn.addEventListener('click', method.handleAccordionClick);
          } else {
            btn.removeEventListener('click', method.handleAccordionClick);
          }
        })
      },
      handleAccordionClick: (event) => {
        event.target.parentNode.classList.toggle('active');
      },
      removeAccordionClass: ()=> {
        objs.el.navOpenBtns.forEach(btn => {
          btn.parentNode.classList.remove('active');
        })
      },
      accordion: ()=>{
        const mediaQuery = window.matchMedia('(max-width: 650px)');

        const checkScreenWidth =()=> {
          if (mediaQuery.matches && !objs.state.isAccordionActive) {
            method.toggleAccordionListeners(true);
            objs.state.isAccordionActive = true;
          } else if (!mediaQuery.matches && objs.state.isAccordionActive) {
            method.toggleAccordionListeners(false);
            objs.state.isAccordionActive = false;
          }
        }

        checkScreenWidth();
        mediaQuery.addEventListener('change', checkScreenWidth);
      },
      checkScrollActive: ()=> {
        objs.el.scrollList.forEach(list => {
          list.addEventListener('click', ()=> {
            objs.el.scrollBtn.parentNode.classList.remove('active');
            objs.el.lnbBtn.parentNode.classList.remove('active');
          })
        })
      },
      onResize: ()=>{
        method.setTheHeight();
        method.accordion();
        method.removeAccordionClass();
      },
      onScroll: (e) => {
        method.checkDistance(objs.state.distance);
      }
    }

    const bindEvent = ()=>{
      window.addEventListener('resize',method.onResize);
      eventEmitter.on('scroll', method.onScroll);
    }

    const initialize = ()=>{
      bindEvent();
      method.onResize();
      method.accordion();
      method.checkScrollActive();
      method.checkCurrentLink();
    }

    return {
      init : initialize,
    }
  }

  const hello = ()=>{
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    const targets  = document.querySelectorAll('[data-hello]');

    targets.forEach(target => {
      const mobileDisable = target.getAttribute('data-hello-mobile') === 'true';

      if (isMobile && mobileDisable) {
        return;
      }

      const setThreshold = parseFloat(target.getAttribute('data-hello-threshold')) || 0.1;
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = target.getAttribute('data-hello-delay') || '0s';
            const duration = target.getAttribute('data-hello-duration') || '0.7s';

            target.style.transitionDelay = `${delay}s`;
            target.style.transitionDuration = `${duration}s`;

            target.classList.add('hello');
            observer.unobserve(target);
          }
        });
      }, { root: document.querySelector('main'),threshold:setThreshold, rootMargin: '100px' });

      observer.observe(target);
    });

  };
  hello();

  const footerTopBtn =()=> {
    const main = document.querySelector('main');
    const topBtn = document.querySelector('.footer__topBtn');

    topBtn.addEventListener('click', ()=> {
      main.scrollTo({
          top: 0,
          behavior: 'smooth'
      })
    })
  }
  footerTopBtn();

  const urlCheck = (page) => {
    const currentUrl = window.location.pathname;
    const sideNAV = document.querySelectorAll('.lnb__wrap .c__container a');

    if (currentUrl.indexOf(page) !== -1) {
      sideNAV.forEach(link => {
        if (link.getAttribute('data-page').toLowerCase() === page) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    }
  }

  const videoCheck = ()=>{
    const main = document.querySelector('main');
    const videoWrap = document.querySelector('.sub__visual-video');
    const video  = videoWrap.querySelector('video');
    const data = {
      height : videoWrap.offsetHeight,
      ratio : 0,
    }

    const method = {
      setData:()=>{
        data.height = videoWrap.offsetHeight;
      },
      calcRatio:()=>{
        data.ratio = Math.min(1,Math.max(0, main.scrollTop / data.height));
        if(data.ratio >= 1){
          video.pause()
          video.currentTime = 0;
        }else{
          video.play()
        }
      }
    }
    eventEmitter.on('scroll',method.calcRatio);
    window.addEventListener('resize',method.setData);
  }

  return{
    setVHVariable : setVHVariable(),
    lnbHandler : lnbHandler(),
    urlCheck,
    videoCheck,
    isMobile,
  }

})();

export { commonFnc , lenisScrollInstance , eventEmitter}

